import { Injectable } from "@angular/core";
import { ITeamCheckIn } from "../interfaces/agent.interface";
import { LogUpload } from "../utils/log-upload";
import { getConvertedDateTime } from "../utils/timeManager";
import { TrsEventsService } from "./trsevents.service";

@Injectable()
export class TeamCheckInService {
    logUploader: LogUpload = new LogUpload("TeamCheckInService");

    private isTeamCheckInActive: boolean = true;
    private teamCheckInInterval: NodeJS.Timeout;
    private teamCheckInUrlMap: Map<string, string> = new Map<string, string>();
    private teamCheckInDateMap: Map<string, Date> = new Map<string, Date>();

    constructor(private trsService: TrsEventsService) {
        this.trsService.evtdata.subscribe((response) => {
            switch (response.eventName) {
                case "TEAMCHECKIN":
                    this.handleTeamCheckInResponse(response.data);
                    break;
                default:
                    break;
            }
        });
    }

    public startTeamCheckInMonitor = (): void => {
        this.trsService.evtdata.next({
            "eventName": "TEAMCHECKIN_REQUEST",
            "data": Object.keys(this.trsService.events)
        });
        this.teamCheckInInterval = setInterval(() => {
            this.trsService.evtdata.next({
                "eventName": "TEAMCHECKIN_REQUEST",
                "data": Object.keys(this.trsService.events)
            });
        }, 60000);
    }

    public stopTeamCheckInMonitor = (): void => {
        if (this.teamCheckInInterval != null)
            clearInterval(this.teamCheckInInterval);

        this.teamCheckInUrlMap.clear();
        this.teamCheckInDateMap.clear();
    }

    private handleTeamCheckInResponse = (data: ITeamCheckIn[]): void => {
        if (data != null && data.length > 0) {
            data.forEach((info: ITeamCheckIn): void => {
                if (info.ImageUrl != null && info.ImageUrl !== "" && info.ImageUrl !== "NA") {
                    this.teamCheckInUrlMap.set(info.LanId, info.ImageUrl);
                    this.teamCheckInDateMap.set(info.LanId, getConvertedDateTime(info.ImageCaptureDateTime));
                }
            });

            this.trsService.evtdata.next({
                "eventName": "TEAMCHECKIN_UPDATE_AVAILABLE",
                "data": ""
            });
        }
    }

    public getTeamCheckInInfo = (lanId: string): ITeamCheckIn => {
        return {
            LanId: lanId,
            ImageUrl: this.teamCheckInUrlMap.get(lanId) ?? "",
            ImageCaptureDateTime: this.teamCheckInDateMap.get(lanId) ?? new Date(0)
        }
    }

    public toggleTeamCheckIn = (): void => {
        this.isTeamCheckInActive = !this.isTeamCheckInActive;

        if (this.isTeamCheckInActive === true)
            this.startTeamCheckInMonitor();
        else this.stopTeamCheckInMonitor();
    }

    public setIsTeamCheckInActive = (isActive: boolean): void => {
        this.isTeamCheckInActive = isActive;
    }

    public getIsTeamCheckInActive = (): boolean => this.isTeamCheckInActive;
}
